module.exports = __webpack_public_path__ + "img/14.3.TP.57cfcd4a.png";